export default function Icon2_3() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3884_40323)">
                <g clipPath="url(#clip1_3884_40323)">
                    <path
                        d="M28.125 2.5C29.8509 2.5 31.25 3.89911 31.25 5.625V34.375C31.25 36.1009 29.8509 37.5 28.125 37.5H11.875C10.1491 37.5 8.75 36.1009 8.75 34.375V5.625C8.75 3.89911 10.1491 2.5 11.875 2.5H28.125Z"
                        stroke="#F8200C"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M17.5 7.5L22.5 7.5" stroke="#F8200C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path
                        d="M21.875 31.875C21.875 32.9105 21.0355 33.75 20 33.75C18.9645 33.75 18.125 32.9105 18.125 31.875C18.125 30.8395 18.9645 30 20 30C21.0355 30 21.875 30.8395 21.875 31.875Z"
                        fill="#F8200C"
                    />
                </g>
                <line x1="9.1492" y1="37.4745" x2="30.1492" y2="3.47451" stroke="#F8200C" strokeWidth="2" />
            </g>
            <defs>
                <clipPath id="clip0_3884_40323">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
                <clipPath id="clip1_3884_40323">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
